import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "no-op",
  "name": "No Operation",
  "category": "utilities",
  "description": "Does nothing - useful for debugging and testing",
  "icon": "CircleSlash",
  "color": "gray",
  "version": "1.0.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "No Op",
    "color": "#6b7280"
  },
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input"
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "noop",
    "debug",
    "test",
    "passthrough"
  ],
  "comingSoon": false
};

export default definition;
